import script from "./AccountModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./AccountModal.vue?vue&type=script&lang=ts&setup=true"

import "./AccountModal.vue?vue&type=style&index=0&id=32ecce6e&lang=scss"

const __exports__ = script;

export default __exports__